window.addEventListener('DOMContentLoaded', function(e) {
    let sliderContainer = document.querySelector('.testimonials .slider-container');

    if (sliderContainer) {
        let prev = sliderContainer.querySelector('button.prev');
        let next = sliderContainer.querySelector('button.next');
        let slider = sliderContainer.querySelector('.slider');
        let total = parseInt(slider.dataset.total);

        prev.addEventListener('click', function(e) {
            backward();
        })

        next.addEventListener('click', function(e) {
            forward();
        })

        function setSlide(target) {
            slider.dataset.pos = target;
        }

        function backward() {
            let currPos = parseInt(slider.dataset.pos);
            let target = currPos - 1;

            if (target == 0) {
                target = total + 1;
                slider.classList.add('reset');
                setSlide(target);

                setTimeout(function(e) {
                    target--;
                    slider.classList.remove('reset');
                    setSlide(target);
                }, 50)
            } else {
                setSlide(target);
            }
        }

        function forward() {
            let currPos = parseInt(slider.dataset.pos);
            let target = currPos + 1;

            if (target == total + 2) {
                target = 1;
                slider.classList.add('reset');
                setSlide(target);

                setTimeout(function(e) {
                    target++;
                    slider.classList.remove('reset');
                    setSlide(target);
                }, 50)
            } else {
                setSlide(target);
            }
        }
    }
})